var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgStep1 = function SvgStep1(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 24.1875,
    y1: 49.71875,
    x2: 24.1875,
    y2: 122.953133,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.078432%,75.686276%,36.078432%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(93.333334%,52.941179%,0%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 51.0625,
    y1: 49.71875,
    x2: 51.0625,
    y2: 122.738129,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.078432%,75.686276%,36.078432%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(93.333334%,52.941179%,0%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 112.875,
    y1: 48.375,
    x2: 112.875,
    y2: 123.625,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.078432%,75.686276%,36.078432%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(93.333334%,52.941179%,0%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 111.544693,
    y1: 69.504128,
    x2: 111.544693,
    y2: 103.64344,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(98.431373%,91.37255%,77.64706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100%,72.941178%,37.254903%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface9286042"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 7.8125 20.3125 L 6.25 20.3125 C 4.953125 20.3125 3.90625 21.359375 3.90625 22.65625 L 3.90625 27.34375 C 3.90625 28.640625 4.953125 29.6875 6.25 29.6875 L 7.8125 29.6875 C 9.109375 29.6875 10.15625 28.640625 10.15625 27.34375 L 10.15625 22.65625 C 10.15625 21.359375 9.109375 20.3125 7.8125 20.3125 Z M 8.59375 27.34375 C 8.59375 27.773438 8.242188 28.125 7.8125 28.125 L 6.25 28.125 C 5.820312 28.125 5.46875 27.773438 5.46875 27.34375 L 5.46875 22.65625 C 5.46875 22.226562 5.820312 21.875 6.25 21.875 L 7.8125 21.875 C 8.242188 21.875 8.59375 22.226562 8.59375 22.65625 Z M 8.59375 27.34375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 11.71875 22.65625 C 11.71875 21.363281 12.769531 20.3125 14.0625 20.3125 L 15.625 20.3125 C 16.917969 20.3125 17.96875 21.363281 17.96875 22.65625 L 17.96875 27.34375 C 17.96875 28.636719 16.917969 29.6875 15.625 29.6875 L 14.0625 29.6875 C 12.769531 29.6875 11.71875 28.636719 11.71875 27.34375 Z M 13.28125 27.34375 C 13.28125 27.773438 13.632812 28.125 14.0625 28.125 L 15.625 28.125 C 16.054688 28.125 16.40625 27.773438 16.40625 27.34375 L 16.40625 22.65625 C 16.40625 22.226562 16.054688 21.875 15.625 21.875 L 14.0625 21.875 C 13.632812 21.875 13.28125 22.226562 13.28125 22.65625 Z M 13.28125 27.34375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 44.898438 22.523438 L 34.546875 14.398438 C 34.078125 14.023438 33.453125 13.960938 32.914062 14.21875 C 32.367188 14.484375 32.03125 15.023438 32.03125 15.632812 L 32.03125 20.3125 L 21.875 20.3125 C 20.578125 20.3125 19.53125 21.367188 19.53125 22.65625 L 19.53125 27.34375 C 19.53125 28.632812 20.585938 29.6875 21.875 29.6875 L 32.03125 29.6875 L 32.03125 34.367188 C 32.03125 34.976562 32.367188 35.515625 32.914062 35.78125 C 33.453125 36.039062 34.078125 35.976562 34.546875 35.601562 L 44.898438 27.46875 C 45.65625 26.875 46.09375 25.976562 46.09375 25 C 46.09375 24.023438 45.65625 23.125 44.898438 22.523438 Z M 43.929688 26.242188 L 33.59375 34.367188 L 33.59375 28.125 L 21.875 28.125 C 21.445312 28.125 21.09375 27.773438 21.09375 27.34375 L 21.09375 22.65625 C 21.09375 22.226562 21.445312 21.875 21.875 21.875 L 33.59375 21.875 L 33.585938 15.625 L 43.929688 23.757812 C 44.3125 24.054688 44.53125 24.507812 44.53125 25 C 44.53125 25.492188 44.3125 25.945312 43.929688 26.242188 Z M 43.929688 26.242188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 35.15625 21.09375 L 35.15625 24.21875 L 22.65625 24.21875 L 22.65625 25.78125 L 35.15625 25.78125 L 35.15625 28.90625 C 35.15625 29.550781 35.890625 29.917969 36.40625 29.53125 L 41.882812 25.621094 C 42.296875 25.308594 42.296875 24.683594 41.882812 24.371094 L 36.40625 20.46875 C 35.890625 20.082031 35.15625 20.449219 35.15625 21.09375 Z M 35.15625 21.09375 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStep1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/step1.f723be88.svg";
export { ForwardRef as ReactComponent };